module.exports = __webpack_public_path__ + "static/media/honor_heart-14.9013ca81.png";